import axios from 'axios';
import { API_BASE_URL } from '../config';

const TOKEN_KEY = 'ac_token';
const USER_KEY = 'ac_user';
const PERMS_KEY = 'ac_permissions';
const IMP_KEY = 'ac_impersonator';

export const storage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),
  getUser: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY));
    } catch {
      return null;
    }
  },
  setUser: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clearUser: () => localStorage.removeItem(USER_KEY),
  getPermissions: () => {
    try {
      return JSON.parse(localStorage.getItem(PERMS_KEY)) || [];
    } catch {
      return [];
    }
  },
  setPermissions: (p) => localStorage.setItem(PERMS_KEY, JSON.stringify(p || [])),
  clearPermissions: () => localStorage.removeItem(PERMS_KEY),
  getImpersonator: () => {
    try {
      return JSON.parse(localStorage.getItem(IMP_KEY));
    } catch {
      return null;
    }
  },
  setImpersonator: (data) => localStorage.setItem(IMP_KEY, JSON.stringify(data)),
  clearImpersonator: () => localStorage.removeItem(IMP_KEY),
  isImpersonating: () => !!localStorage.getItem(IMP_KEY),
  clearAll: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(PERMS_KEY);
    localStorage.removeItem(IMP_KEY);
  },
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = storage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let onUnauthorized = null;
export const setOnUnauthorized = (fn) => {
  onUnauthorized = fn;
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      storage.clearAll();
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export const extractError = (error, fallback = 'Something went wrong') => {
  if (error.response && error.response.data) {
    const data = error.response.data;
    if (data.errors) {
      const first = Object.keys(data.errors);
      return first.length ? data.errors[first[0]][0] : fallback;
    }
    return data.message || fallback;
  }
  if (error.message === 'Network Error') {
    return 'Network error. Please check your internet connection.';
  }
  return fallback;
};

export default api;
